import React from "react";
import ConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";

// Shared by the Users and User Types tabs for delete confirmations -
// replaces the browser's native window.confirm() with something styled
// consistently with the rest of the admin UI.
export default ConfirmationDialog;
